<template>
  <div class="no-data-container" :style="{marginTop}">
    <img src="@/assets/img/qietu/nodata.png" alt="" />
    <p>暂无数据</p>
  </div>
</template>

<script>
export default {
  props: {
    marginTop: {
      type: String,
      default: '200px'
    }
  }
};
</script>

<style lang="scss" scoped>
.no-data-container {
  // position: absolute;
  width: 100%;
  text-align: center;
  font-size: 14px;
  font-family: PingFang SC;
  color: #666666;
  flex: 1;
  img {
    margin-bottom: 20px;
    width: 285px;
    height: 240px;
  }
}
</style>
